module.exports = __webpack_public_path__ + "static/media/a_03.bc199112.jpg";